<template>
  <div>
    <UserForm ref="refUserForm" :userData="userData" />
  </div>
</template>

<script>
import UserForm from "./userForm/UserForm.vue";

export default {
  components: {
    UserForm
  },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {},
};
</script>
